module.exports = __webpack_public_path__ + "img/rules_icon.410152f2.png";